import React, { useEffect, useState } from "react";
import * as Survey from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";
import $ from "jquery";
import * as SurveyCore from "survey-core";
import "survey-core/defaultV2.min.css";

import { Model } from "survey-core";
import "survey-core/defaultV2.min.css";
import { jqueryuidatepicker } from "surveyjs-widgets";
import "jquery-ui-dist/jquery-ui.css";
import { useTranslation } from "react-i18next";

window["$"] = window["jQuery"] = $;
require("jquery-ui-dist/jquery-ui.js");

jqueryuidatepicker(SurveyCore);

const SurveyPreviewModal = ({ surveyConfig, isOpen, onClose, isConsensus }) => {
  const [survey, setSurvey] = useState(null);
  const {t} = useTranslation();
  useEffect(() => {
    if (surveyConfig != null && Object.keys(surveyConfig).length >0) { 

      let copySurveyConfig = JSON.parse(JSON.stringify(surveyConfig));

    
      

  

      const wrapHtmlInPanels = (survey) => {
        if (!survey || !survey.pages) return survey; // Se survey è null o non ha pagine, non fare nulla
    
        return {
            ...survey,
            pages: survey.pages.map(page => ({
                ...page,
                elements: page.elements.map(element =>
                    element.type === "html"
                        ? {
                            type: "panel",
                            name: `${element.name}-panel`,
                            title: element.title && element.title !== t('survey.surveyPreviewModal.welcomeVoiceToTheExperts') ? element.title : ""
                            ,
                            elements: [element]  // Wrap HTML inside panel
                        }
                        : element
                )
            }))
        };
    };
    
      
      const surveyModel = new Survey.Model(  wrapHtmlInPanels(copySurveyConfig));
      surveyModel.onValueChanged.add(function(sender, options) {
        const dropdownNames = ["skilled_in1", "skilled_in2", "skilled_in3"];
    
        // Recupera tutti i valori selezionati
        let selectedValues = dropdownNames.map(name => sender.getValue(name)).filter(val => val);
    
        // Aggiorna le scelte di ogni dropdown
        dropdownNames.forEach(name => {
            let question = sender.getQuestionByName(name);
            if (question) {
                let allChoices = [
                  "Redditi, disuguaglianza e povertà",
                  "Tassazione",
                  "Lavoro",
                  "Conti pubblici",
                  "Imprese, concorrenza e regolamentazione",
                  "Energia e ambiente",
                  "Inflazione e politica monetaria",
                  "Infrastrutture e trasporti",
                  "Demografia e immigrazione",
                  "Istituzioni",
                  "Politiche commerciali",
                  "Divari territoriali",
                  "Istruzione e ricerca",
                  "Sanità",
                  "Pensioni",
                  "Banche, assicurazioni e mercati finanziari"
                ];
    
                // Filtra choices: mantiene la scelta attuale e rimuove quelle già selezionate altrove
                question.choices = allChoices.filter(choice => 
                    choice === sender.getValue(name) || !selectedValues.includes(choice)
                );
    
                sender.render();

            }
        });
    });

      setSurvey(surveyModel);
      
    }
  }, [surveyConfig]);

  // Resetta la pagina iniziale ogni volta che il modale si apre
  useEffect(() => {
    if (survey && isOpen) {
      survey.currentPageNo = 0; // Torna alla prima pagina
      survey.clear(); // Resetta le risposte
    }
  }, [survey, isOpen]);


  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('survey.surveyPreviewModal.surveyPreview')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {survey ? (
            <Box
              h="80vh"
              p={4}
              bg="gray.50"
              rounded="md"
              shadow="md"
              overflowY="auto"
            >
              <Survey.Survey model={survey} onComplete={()=>survey.clear()} />
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="80vh"
              p={5}
            >
              <Spinner size="lg" color="blue.500" />
              <Text ml={3} fontSize="lg" color="gray.600">
                {t('survey.surveyPreviewModal.loadingSurvey')}
              </Text>
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            {t('survey.surveyPreviewModal.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SurveyPreviewModal;
